<template>
    <div class="publication__editor">

        <div class="publication__editor-wrap  d-flex">
            <div class="publication__editor-item">
                <div class="publication__fieldset">
                    <div class="publication__fieldset-title">Заголовок</div>
                    <div class="publication__fieldset-input">
                        <input type="text" v-model="$v.name.$model" placeholder="Введите заголовок объявления">
                    </div>
                    <div class="text-danger" v-show="$v.name.$error">Неверное значение.</div>
                </div>
                <div class="publication__fieldset publication__fieldset--textarea-large">
                    <div class="publication__fieldset-title">Описание</div>
                    <div class="publication__fieldset-input">
                        <textarea v-model="$v.description.$model" placeholder="Введите общий текст для объявления"></textarea>
                    </div>
                    <div class="text-danger" v-show="$v.description.$error">Неверное значение.</div>
                </div>
            </div>
            <div class="publication__editor-item">

                <div class="publication__section-item">
                    <div class="publication__section-title">Тип услуг:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.type.$model" value="photo_help">
                                <span class="circle"></span>
                                Фотопомощь
                            </label>
                        </div>
                        <div class="publication__section-list-item">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.type.$model" value="pr_help">
                                <span class="circle"></span>
                                PR
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.type.$error">Неверное значение.</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">Платно/бесплатно:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.charge_categories">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.charge_category.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.charge_category.$error">Неверное значение.</div>

                </div>

                <div class="publication__section-item">
                    <div class="publication__section-title">Доступность:</div>
                    <div class="publication__section-list d-flex">
                        <div class="publication__section-list-item" v-for="(value, key) in serverDictionary.ranges">
                            <label class="d-flex">
                                <input type="radio" v-model="$v.range.$model" :value="key">
                                <span class="circle"></span>
                                {{value}}
                            </label>
                        </div>
                    </div>

                    <div class="text-danger" v-if="$v.range.$error">Неверное значение.</div>

                </div>

            </div>
        </div>

    </div>
</template>

<script>

import { required, maxLength } from 'vuelidate/lib/validators';
import StateMixin from "../mixins/StateMixin";
export default {
    name: "PhotoHelpForm",
    props: ['server'],
    mixins: [ StateMixin ],
    computed:{

        serverDictionary(){ return this.server.dictionaries },

        name: {
            get() { return this.GET_BY_KEY('name') },
            set( val ) {
                this.SET_BY_KEY({key: 'name', data: val})
            }
        },

        description: {
            get() { return this.GET_BY_KEY('description') },
            set( val ) {
                this.SET_BY_KEY({key: 'description', data: val})
            }
        },

        type: {
            get() { return this.GET_BY_KEY('type') },
            set( val ) {
                this.SET_BY_KEY({key: 'type', data: val})
            }
        },

        charge_category: {
            get() { return this.GET_BY_KEY('charge_category') },
            set( val ) {
                this.SET_BY_KEY({key: 'charge_category', data: val})
            }
        },

        range: {
            get() { return this.GET_BY_KEY('range') },
            set( val ) {
                this.SET_BY_KEY({key: 'range', data: val})
            }
        },

    },

    methods:{
        isValid(){
            this.$v.$touch();

            if( this.$v.$invalid ){
                this.$emit('parent-update', false );
                return false
            }

            this.$emit('parent-update', true )
            return true

        }
    },

    validations: {
        name:            { required },
        charge_category: { required },
        type:            { required },
        range:           { required },
        description:     { required, maxLength: maxLength(3000) },
    }


}
</script>

<style scoped>

</style>
